import { render } from "./wxmcontact.vue?vue&type=template&id=67e7834c&scoped=true"
import script from "./wxmcontact.vue?vue&type=script&lang=js"
export * from "./wxmcontact.vue?vue&type=script&lang=js"

import "./wxmcontact.vue?vue&type=style&index=0&id=67e7834c&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e7834c"]])

export default __exports__